/**
 * Created by staffanrantzow on 16/03/16.
 */

/* @flow */
import React from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';

export class Footer extends React.Component {

  render () {
    return (
      <footer className='site-footer'>

        <div className='container'>
          <div className='row'>
            <div className='col-sm-4'>
              <h3><Translate content='INFORMATION'/></h3>
              <ul className='footer-list'>
                <li>
                  <a href={proxyCounterpart('FOOTER_LINK_FAQ')} target='_blank'><Translate content='FAQ'/></a>
                </li>
                <li>
                  <a href={proxyCounterpart('FOOTER_LINK_SUPPORT')} target='_blank'>
                    <Translate content='SUPPORT'/>
                  </a>
                </li>
                <li>
                  <a href={proxyCounterpart('FOOTER_LINK_CONTACT')} target='_blank'>
                    <Translate content='CONTACT'/>
                  </a>
                </li>
                <li>
                  <a
                    href={proxyCounterpart('FOOTER_LINK_PRIVACY_POLICY')}
                    target='_blank'>
                    <Translate content='PRIVACY_POLICY'/>
                  </a>
                </li>
                <li>
                  <a href={proxyCounterpart('FOOTER_LINK_INS')} target='_blank'>
                    <Translate content='INSURANCES'/>
                  </a>
                </li>
              </ul>
            </div>
            <div className='col-sm-4 hide-tablet'>
              <h3><Translate content='SOCIAL_MEDIAS'/></h3>
              <ul className='footer-list social-media-list'>
                <li className='facebook'>
                  <a href={proxyCounterpart('FOOTER_LINK_FACEBOOK')} target='_blank'>
                    <Translate content='FACEBOOK'/>
                  </a>
                </li>
                <li className='linkedin'>
                  <a href={proxyCounterpart('FOOTER_LINK_LINKEDIN')} target='_blank'>
                    <Translate content='LINKEDIN'/>
                  </a>
                </li>
                <li className='twitter'>
                  <a href={proxyCounterpart('FOOTER_LINK_TWITTER')} target='_blank'>
                    <Translate content='TWITTER'/>
                  </a>
                </li>
                <li className='instagram'>
                  <a href={proxyCounterpart('FOOTER_LINK_INSTAGRAM')} target='_blank'>
                    <Translate content='INSTAGRAM'/>
                  </a>
                </li>
              </ul>
            </div>
            <div className='col-sm-4 hide-tablet'>
              <h3><Translate content='CONTACT'/></h3>
              <ul className='footer-list'>
                <li className='contact-text'>
                  <Translate content='FOOTER_CONTACT_EMAIL'/>
                </li>
                <li className='contact-text'>
                  <Translate content='FOOTER_CONTACT_PHONE'/>
                </li>
                <li className='contact-text'>
                  <Translate content='FOOTER_CONTACT_OPEN'/>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='footer-bottom'>
          <div className='container'>
            <p className='copywright'>&copy;{new Date().getFullYear()} - Frilans Finans AB</p>
            <a href={proxyCounterpart('FOOTER_LINK_COOKIE')} target='_blank'><Translate content='COOKIE_INFO'/></a>

            <div className='footer-logo  hide-tablet'>
              <img src={require('images/logos/egenanstallning.png')}
                alt='Egenanställningsföretagens Branschorganisation' />
            </div>
          </div>
        </div>

      </footer>
    );
  }
}

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/footer/footer.js
 **/